var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-wrapper"},[(_vm.content.field_headline)?_c('h2',[_vm._v(_vm._s(_vm.content.field_headline))]):_vm._e(),_c('span',{domProps:{"innerHTML":_vm._s(_vm.content.field_text)}}),_c('google-map',{attrs:{"addresses":_vm.content.paragraph}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }